import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../reducer/context";
import toast from "react-hot-toast";
import * as staticConstants from '../../translations/en/en'
import * as ApiConst from "../../api/ApiConst"
import { callPostApi } from "../../api/ApiCaller";
import { InformationAlert } from "../common";
import { initialUserDetail } from "../../reducer/initialStates/initialStates";
import { NO_ERROR } from "../../api/constants";
import { EDIT_PROFILE } from "../../reducer/actions/userActions";
import textUtils from "../../utils/TextUtils";
import dateUtilities from "../../utils/DateUtilities";
import * as clevertapEvents from '../../clevertapEvents'
import { confirmAlert } from "react-confirm-alert";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { WhatsAppUnderlineGreen } from "../common/svgIcons";
import Modal from 'react-modal';

const AUTO_REDIRECT_DELAY = 5;
export const OffersPage = ({ type }) => {
    const { authState, dispatchAuth } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState({ ...initialUserDetail });
    const [countdown, setCountdown] = useState(AUTO_REDIRECT_DELAY);
    const [whatsappLink, setWhatsappLink] = useState('');
    const [showDialog, setShowDialog] = useState(false);
    const [errors, setErrors] = useState({});
    const location = useLocation();
    const { value } = useParams();
    const { search } = location;
    const urlParams = new URLSearchParams(search);
    const via = urlParams.get('via') || 'N/A';

    const { user, isAuthenticated } = authState

    useEffect(() => {
        if (isAuthenticated && user) {
            setUserDetails(user);
        }
    }, [isAuthenticated, user]);

    // Countdown effect
    useEffect(() => {
        let interval;
        if (showDialog && countdown > 0) {
            interval = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        window.open(whatsappLink, '_blank');
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [showDialog, countdown, whatsappLink]);


    const handleUserDetailsChange = (event) => {
        const { name, value } = event.target
        setUserDetails((prev) => ({ ...prev, [name]: value }));
        setErrors({ [name]: "" });
    };

    const validateUserDetails = (flag = false) => {
        if (!userDetails.fullName) {
            setErrors({ fullName: staticConstants.PLEASE_ENTER_FULL_NAME });
            return false;
        }
        if (!textUtils.isEmail(userDetails.email)) {
            setErrors({ email: staticConstants.PLEASE_ENTER_VALID_EMAIL });
            return false;
        }
        if (!userDetails.dateOfBirth) {
            setErrors({ dateOfBirth: staticConstants.PLEASE_SELECT_DOB });
            return false;
        }
        if (!userDetails.gender) {
            setErrors({ gender: staticConstants.PLEASE_SELECT_GENDER });
            return false;
        }
        setErrors({});
        return true;
    };

    const handleWhatsAppClick = () => {
        setShowDialog(false);
        setCountdown(AUTO_REDIRECT_DELAY);
        setWhatsappLink('');
        navigate('/offers', { state: { isRedirect: true } });
    };

    const showUpdateSuccessAlert = () => {
        const message = `Hello! Could you please check the status of my coupon?`;
        const encodedMessage = encodeURIComponent(message);
        const link = `https://wa.me/${staticConstants.ADMIN_MOBILE_NUMBER}?text=${encodedMessage}`;
        setWhatsappLink(link);
        setCountdown(AUTO_REDIRECT_DELAY);
        setShowDialog(true);
    }

    const updateUserDetails = () => {
        if (!validateUserDetails(true)) {
            return;
        }
        const toastId = toast.loading(staticConstants.PLEASE_WAIT);
        const { anniversaryDate, dateOfBirth, userImage, ...restUserDetails } = userDetails
        const dob = new Date(dateOfBirth);
        const anniversaryDateObj = new Date(dateOfBirth);
        const dobTimeStamp = dob.getTime();
        const anniversaryTimeStamp = anniversaryDateObj.getTime();
        let rObj = {
            ...restUserDetails,
            anniversarydate: anniversaryTimeStamp,
            createcustomeronpaymentgateway: false,
            dateOfBirth: dobTimeStamp,
            userImageUrl: userImage
        };
        callPostApi(ApiConst.Update_Profile, rObj, {}, (response) => {
            toast.dismiss(toastId)
            if (response.errorCode === NO_ERROR) {
                try {
                    
                    // clevertapEvents.customSignUpViaEvent(via);
                    showUpdateSuccessAlert();
                    dispatchAuth({
                        type: EDIT_PROFILE,
                        payload: response.responsePacket,
                    });

                    clevertapEvents.profileEvent(response.responsePacket);
                    const christmasOfferObj = {
                        fullName: response.responsePacket.fullName,
                        mobile: response.responsePacket.mobile,
                        email: response.responsePacket?.email,
                    }
                    if (type === 'cash') {
                        clevertapEvents.christmasOfferEvent(`QR-Cash`, christmasOfferObj);
                    } else {
                        if (value) {
                            clevertapEvents.christmasOfferEvent(`QR Offer ${value}`, christmasOfferObj);
                        } else {
                            clevertapEvents.christmasOfferEvent(`QR Offer`, christmasOfferObj);
                        }
                    }
                } catch (error) {
                    console.error("Error in updating profile", error)
                }
                // if (showEditProfileModal) {
                //     dispatchAuth({ type: TOGGLE_EDIT_PROFILE_MODAL })
                //     navigate("/", { replace: true })
                // }
            } else {
                InformationAlert({ message: response.message })
            }
        });
    };

    const handleCloseModal = () => {
        setShowDialog(false);
        setCountdown(AUTO_REDIRECT_DELAY);
        setWhatsappLink('')
    }

    return (
        <>
            <div className='special-header'>
                <Link to='/' className='brand-wrap mb-0'>
                    <img alt='logo' className='img-fluid mobile-logo' src='../img/mobile_logo.png' width="612" height="152" style={{ width: "auto" }} />
                </Link>
            </div>
            <div className="special-ocassion my-2">
                <div className='Events_Details bg-white shadow-sm col-xl-3 col-lg-4 col-md-6 col-sm-8 col-xs-12 h-100 p-4'>
                    <div>
                        <div className="text-center mb-2" style={{ fontSize: '20px', fontWeight: 800, textDecoration: 'underline' }}>Get Special Offer</div>
                        <div>
                            <label
                                className="mb-0 text-secondary font-size-12 font-weight-700"
                                htmlFor="inputAddress"
                            >
                                {staticConstants.NAME}
                            </label>
                            <input
                                type="text"
                                className="form-control table-form mb-2 "
                                id="inputAddress"
                                name="fullName"
                                value={userDetails.fullName}
                                onChange={handleUserDetailsChange}
                            />
                            {errors.fullName && (<span style={{ color: "#cf000f" }}>{errors.fullName}</span>)}
                        </div>
                        <div>
                            <label
                                className="mb-0 text-secondary font-size-12 font-weight-700"
                                htmlFor="inputAddress2"
                            >
                                {staticConstants.EMAIL_ADDRESS}
                            </label>
                            <input
                                type="email"
                                className="form-control table-form mb-2"
                                id="inputAddress2"
                                name="email"
                                value={userDetails.email}
                                onChange={handleUserDetailsChange}
                            />
                            {errors.email && (<span style={{ color: "#cf000f" }}>{errors.email}</span>)}
                        </div>
                        <div>
                            <label
                                className="mb-0 text-secondary font-size-12 font-weight-700"
                                htmlFor="inputEmail4"
                            >
                                {staticConstants.DATE_OF_BIRTH} {"{"}DD/MM/YYYY{"}"}
                            </label>
                            <input
                                type="date"
                                className="form-control table-form mb-2"
                                name="dateOfBirth"
                                value={
                                    userDetails.dateOfBirth ?
                                        dateUtilities.formattedDate(
                                            userDetails.dateOfBirth,
                                            "yyyy-MM-dd"
                                        ) : ""
                                }
                                onChange={handleUserDetailsChange}
                            />
                            {errors.dateOfBirth && (<span style={{ color: "#cf000f" }}>{errors.dateOfBirth}</span>)}
                        </div>
                        <div>
                            <label
                                className="mb-0 text-secondary font-size-12 font-weight-700"
                                htmlFor="inputEmail4"
                            >
                                {staticConstants.ANNIVERSARY_DATE} {"{"}DD/MM/YYYY{"}"}
                            </label>
                            <input
                                type="date"
                                className="form-control table-form mb-2"
                                name="anniversaryDate"
                                value={
                                    userDetails.anniversaryDate ?
                                        dateUtilities.formattedDate(
                                            userDetails.anniversaryDate,
                                            "yyyy-MM-dd"
                                        ) : ""
                                }
                                onChange={handleUserDetailsChange}
                            />
                            {errors.anniversaryDate && (<span style={{ color: "#cf000f" }}>{errors.anniversaryDate}</span>)}
                        </div>
                        <fieldset className="form-group">
                            <div className="row justify-content-center align-items-center mx-auto">
                                <div className="col-3 pl-0">
                                    <legend className="col-form-label pb-0   font-weight-800 font-size-16 text-dark-gray float-sm-left pt-0">
                                        {staticConstants.GENDER}:
                                    </legend>
                                </div>
                                <div className="col-3 cursor-pointer">
                                    <div className="custom-control px-0 custom-radio">
                                        <input
                                            className="custom-control-input h-0 w-0"
                                            type="radio"
                                            name="gender"
                                            id="genderMale"
                                            value={userDetails.gender}
                                            onChange={() =>
                                                setUserDetails({
                                                    ...userDetails,
                                                    gender: "MALE",
                                                })
                                            }
                                            checked={userDetails.gender === "MALE"}
                                        />
                                        <label
                                            className="custom-control-label font-size-14 font-weight-600 w-100 p-0 cursor-pointer line-height-24"
                                            htmlFor="genderMale"
                                        >
                                            {staticConstants.MALE}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-3 cursor-pointer">
                                    <div className="custom-control px-0 custom-radio">
                                        <input
                                            className="custom-control-input h-0 w-0"
                                            type="radio"
                                            name="gender"
                                            id="genderFemale"
                                            value={userDetails.gender}
                                            onChange={() =>
                                                setUserDetails({
                                                    ...userDetails,
                                                    gender: "FEMALE",
                                                })
                                            }
                                            checked={userDetails.gender === "FEMALE"}
                                        />
                                        <label
                                            className="custom-control-label font-size-14 font-weight-600  w-100 p-0 cursor-pointer line-height-24"
                                            htmlFor="genderFemale"
                                        >
                                            {staticConstants.FEMALE}
                                        </label>
                                    </div>
                                </div>
                                <div className="col-3 cursor-pointer">
                                    <div className="custom-control px-0 custom-radio">
                                        <input
                                            className="custom-control-input h-0 w-0"
                                            type="radio"
                                            name="gender"
                                            id="genderOther"
                                            value={userDetails.gender}
                                            onChange={() =>
                                                setUserDetails({
                                                    ...userDetails,
                                                    gender: "other",
                                                })
                                            }
                                            checked={userDetails.gender === "other"}
                                        />
                                        <label
                                            className="custom-control-label font-size-14 font-weight-600  w-100 p-0 cursor-pointer line-height-24"
                                            htmlFor="genderOther"
                                        >
                                            {staticConstants.OTHER}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {errors.gender && (<span style={{ color: "#cf000f" }}>{errors.gender}</span>)}
                        </fieldset>
                        <button
                            onClick={updateUserDetails}
                            className="btn bg-yellow text-black custom-btn w-100"
                        >
                            {staticConstants.SUBMIT}
                        </button>
                    </div>
                    <div className="mt-2" style={{ textAlign: 'justify' }}>*{staticConstants.USER_DATA_SECURE}</div>
                </div>
            </div>
            <Modal
                className={"modal-dialog modal-dialog-centered modalBox"}
                isOpen={showDialog}
                onRequestClose={handleCloseModal}
                shouldCloseOnOverlayClick={true}
                overlayClassName={'whatsapp-offer-modal'}
            >
                <div className="modal-content">
                    <div className="bg-white text-center p-4" style={{ borderRadius: '12px' }}>
                        <div className="pb-3">
                            {/* <img
                        src={userDetails.userImage ? userDetails.userImage : "../img/check.png"}
                        alt="profile"
                        style={{
                            width: "70px",
                            height: " 70px",
                            borderRadius: "50%",
                            objectFit: "cover"
                        }}
                    /> */}
                            <WhatsAppUnderlineGreen fill="#25D366" />
                        </div>
                        {/* <p className="mb-0 font-size-16 font-weight-700 pb-3" style={{ whiteSpace: 'pre-line' }}>
                    {staticConstants.CHRISTMAS_OFFER_TEXT}
                </p> */}
                        <h4 className="font-size-18 font-weight-700 pb-3 text-black mt-2 d-flex align-items-center justify-content-center" style={{ gap: "10px" }}><img src="../img/party-img.png" alt="" style={{ width: "35px" }} /> Registration Successful! <img src="../img/party-img.png" alt="" style={{ width: "35px" }} /> </h4>
                        <p>
                            Thank you for registering yourself for this exclusive offer!<br />
                            <strong>Your coupon is ready and waiting for you on WhatsApp.</strong><br />
                            Kindly click on the WhatsApp button below to start a<br /> conversation with us and receive your coupon instantly.
                        </p>
                        <a
                            href={whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn w-100 text-white d-flex align-items-center justify-content-center"
                            style={{
                                backgroundColor: '#25D366',
                                borderRadius: '100px',
                                padding: '12px 24px',
                                fontSize: '16px',
                                fontWeight: '600',
                                marginTop: '10px'
                            }}
                            onClick={handleWhatsAppClick}
                        >
                            <WhatsAppUnderlineGreen fill="#fff" />
                            Click Here to Get Your Coupon on WhatsApp
                        </a>
                        <p className="font-weight-700 font-size-14 mt-3 text-center">
                            Auto-redirecting to WhatsApp in <strong style={{ color: "#6E86D8" }}>{countdown}</strong> seconds
                        </p>
                    </div>
                </div>
            </Modal>
        </>
    );
};